import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { ReactFlowProvider } from 'reactflow';
export const GraphContext = /*#__PURE__*/ React.createContext({
    viewPortCache: new Map()
});
export function GraphProvider({ children }) {
    const viewPortCache = useMemo(()=>new Map(), []);
    return /*#__PURE__*/ _jsx(ReactFlowProvider, {
        children: /*#__PURE__*/ _jsx(GraphContext.Provider, {
            value: {
                viewPortCache: viewPortCache
            },
            children: children
        })
    });
}
export function useGraphContext() {
    return React.useContext(GraphContext);
}
